import { render, staticRenderFns } from "./skr-pagination.vue?vue&type=template&id=3e98e807"
import script from "./skr-pagination.vue?vue&type=script&lang=js"
export * from "./skr-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports